import { useState } from "react";
import { DateRangePicker } from "react-date-range";

import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file

export default function CustomDatePickerRange({setDate, preSelectedValue, minMax}) {

    const [state, setState] = useState([
        {
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection'
        }
    ]);

    function handleSelect(ranges){
        setState([ranges.selection])
        if (setDate) {
            setDate(ranges.selection)
        }

    }

    // useEffect(() => {
    //     if (preSelectedValue) {
    //         if (preSelectedValue.includes('|')) {
    //             let dateArray = preSelectedValue.split('|')
    //             setState([{                    
    //                 startDate: new Date(dateArray[0]),
    //                 endDate: new Date(dateArray[0]),
    //                 key: 'selection'
    //             }])
    //         } else {
    //             setState([{
    //                 startDate: new Date(preSelectedValue),
    //                 endDate: new Date(preSelectedValue),
    //                 key: 'selection'
    //             }])
    //         }
    //     }
    // }, [preSelectedValue])

    return  <DateRangePicker
        onChange={handleSelect}
        showSelectionPreview={true}
        moveRangeOnFirstSelection={false}
        months={2}
        ranges={state}
        direction="horizontal"
        minDate={minMax ? minMax.min : undefined}
        maxDate={minMax ? minMax.max : undefined}        
    />
}
